import { isPreSale } from 'common/helpers/featureFlags';

import Frequency from './details/Frequency';
import PaymentMethod from './details/PaymentMethod';

const ClubMembershipDetails = (props) => {
  const { clubMembership } = props;
  let viewTitle = 'Club Membership';
  if (isPreSale()) {
    viewTitle = 'Pre-Sale';
  }
  return (
    <div className="c7-order__customer-detail">
      <h4>{viewTitle} information</h4>
      <div>
        <PaymentMethod clubMembership={clubMembership} />
        {clubMembership.club.type === 'Subscription' && (
          <Frequency clubMembership={clubMembership} />
        )}
      </div>
    </div>
  );
};

export default ClubMembershipDetails;
